<template>
    <div>
        <v-footer app color="bal-gray"
            ><span>Tootja.ee</span>
            <v-spacer />
            <span>&copy; {{ new Date().getFullYear() }}</span>
        </v-footer>
    </div>
</template>

<script>
export default {
    name: "page-footer"
};
</script>

<style scoped></style>
